import React, { useState, useEffect } from 'react'
import api from '../../services/api'
import { useAuthStore } from '../../stores/authStore.js'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { useTrusteesFooter, renderTrusteesHtml } from '../../components/reportTrusteesFooter'

function BukuBesar() {
  const { user } = useAuthStore()
  const [ledgerData, setLedgerData] = useState([])
  const [loading, setLoading] = useState(true)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [startDay, setStartDay] = useState('1');
  const [startMonth, setStartMonth] = useState('');
  const [startYear, setStartYear] = useState('');
  const [endDay, setEndDay] = useState('');
  const [endMonth, setEndMonth] = useState('');
  const [endYear, setEndYear] = useState('');
  const [coopProfile, setCoopProfile] = useState(null)
  const [branchInfo, setBranchInfo] = useState(null)
  const [logoBase64, setLogoBase64] = useState('')
  const { trustees } = useTrusteesFooter(startDate, endDate)

  const formatDate = (dateString) => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return date.toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' })
  }

  useEffect(() => {
    const loadLogo = async () => {
      try {
        const response = await fetch('/logo.jpeg')
        const blob = await response.blob()
        const reader = new FileReader()
        reader.onloadend = () => setLogoBase64(reader.result)
        reader.readAsDataURL(blob)
      } catch (e) { console.log('Failed to load logo') }
    }
    loadLogo()
  }, [])

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '0'
    return new Intl.NumberFormat('id-ID').format(value)
  }

  useEffect(() => {
    const today = new Date()
    const y = today.getFullYear()
    const m = String(today.getMonth() + 1).padStart(2, '0')
    const d = String(today.getDate()).padStart(2, '0')
    setStartYear(String(y))
    setStartMonth('01')
    setStartDay('01')
    setEndYear(String(y))
    setEndMonth(m)
    setEndDay(d)

    const fetchProfileInfo = async () => {
      try {
        const response = await api.get('/reports/profile-info')
        setCoopProfile(response.data.data.coopProfile)
        setBranchInfo(response.data.data.branchInfo)
      } catch (error) {
        console.error('Error fetching profile info:', error)
      }
    }
    fetchProfileInfo()
  }, [])


  // Compose date strings from dropdown parts
  useEffect(() => {
    if (startYear && startMonth && startDay) {
      setStartDate(`${startYear}-${startMonth}-${startDay}`)
    }
  }, [startYear, startMonth, startDay])

  useEffect(() => {
    if (endYear && endMonth && endDay) {
      setEndDate(`${endYear}-${endMonth}-${endDay}`)
    }
  }, [endYear, endMonth, endDay])

  const fetchLedgerData = async () => {
    if (!startDate || !endDate) return

    setLoading(true)
    try {
      const response = await api.get('/reports/buku-besar', {
        params: { startDate, endDate }
      })
      setLedgerData(response.data.data)
    } catch (error) {
      console.error('Error fetching ledger data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (startDate && endDate) {
      fetchLedgerData()
    }
  }, [startDate, endDate])

  const handlePrint = () => {
    const printContent = `
      <html>
        <head>
          <title>Laporan Buku Besar</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 12px; padding: 20px; }
            .kop-surat { text-align: center; border-bottom: 3px solid #000; padding-bottom: 15px; margin-bottom: 20px; }
            .kop-surat-inner { display: flex; align-items: center; gap: 15px; }
            .logo { width: 70px; height: auto; }
            .kop-text { text-align: center; flex: 1; }
            .kop-nama { font-size: 20px; font-weight: bold; margin: 5px 0; }
            .kop-badan-hukum { font-size: 12px; margin: 3px 0; }
            .kop-alamat { font-size: 11px; margin: 2px 0; }
            .kop-kontak { font-size: 10px; margin: 2px 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th, td { border: 1px solid #ccc; padding: 5px; text-align: left; }
            th { background-color: #f0f0f0; font-weight: bold; }
            .account-header { background-color: #e8f4f8; font-weight: bold; }
            .number { text-align: right; }
            @media print { body { margin: 0; } }
          </style>
        </head>
        <body>
          <div class="kop-surat">
            <div class="kop-surat-inner">
              <img src="${window.location.origin}/logo.jpeg" class="logo" alt="Logo" />
              <div class="kop-text">
                <div class="kop-nama">${coopProfile?.NamaKoperasi || 'KOPERASI SERBA USAHA'}</div>
                <div class="kop-badan-hukum">Badan Hukum No. : ${coopProfile?.NoBadanHukum || '-'}</div>
                <div class="kop-alamat">${coopProfile?.Alamat || ''}</div>
                <div class="kop-kontak">Telp: ${coopProfile?.Telepon || '-'}  |  Email: ${coopProfile?.Email || '-'}  |  Website: ${coopProfile?.Website || '-'}  |  NPWP: ${coopProfile?.NPWP || '-'}</div>
              </div>
            </div>
          </div>
          <h4 style="text-align: center; margin-bottom: 15px;">LAPORAN BUKU BESAR</h4>
          <div class="info">
            <p>Periode: ${formatDate(startDate)} s/d ${formatDate(endDate)}</p>
            <p>Cabang: ${branchInfo?.NamaCabang || user?.cabangId || '-'}</p>
          </div>
          ${ledgerData.map(account => `
            <h5 style="background: #e8f4f8; padding: 5px; border-left: 3px solid #007bff; font-weight: bold;">${account.KodeAkun} - ${account.NamaAkun}</h5>
            <table>
              <thead>
                <tr>
                  <th>Tanggal</th>
                  <th>No Jurnal</th>
                  <th>No Referensi</th>
                  <th>Keterangan</th>
                  <th class="number">Debet</th>
                  <th class="number">Kredit</th>
                  <th class="number">Saldo</th>
                </tr>
              </thead>
              <tbody>
                ${account.transactions.map(t => `
                  <tr>
                    <td>${formatDate(t.TglJurnal)}</td>
                    <td>${t.NoJurnal}</td>
                    <td>${t.NoReferensi}</td>
                    <td>${t.Keterangan}</td>
                    <td class="number">${t.Debet > 0 ? formatCurrency(t.Debet) : '-'}</td>
                    <td class="number">${t.Kredit > 0 ? formatCurrency(t.Kredit) : '-'}</td>
                    <td class="number">${formatCurrency(t.Saldo)}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
            <br/>
          `).join('')}
          ${renderTrusteesHtml(trustees)}
        </body>
      </html>
    `

    const printWindow = window.open('', '_blank')
    printWindow.document.write(printContent)
    printWindow.document.close()
    printWindow.print()
  }

  const handleExportExcel = async () => {
    const wb = XLSX.utils.book_new()

    let wsData = [
      [coopProfile?.NamaKoperasi || 'KOPERASI SERBA USAHA'],
      [`Badan Hukum No. : ${coopProfile?.NoBadanHukum || '-'}`],
      [coopProfile?.Alamat || ''],
      [`Telp: ${coopProfile?.Telepon || '-'}  |  Email: ${coopProfile?.Email || '-'}  |  Website: ${coopProfile?.Website || '-'}  |  NPWP: ${coopProfile?.NPWP || '-'}`],
      [],
      ['LAPORAN BUKU BESAR'],
      [`Periode: ${formatDate(startDate)} s/d ${formatDate(endDate)}`],
      [`Cabang: ${branchInfo?.NamaCabang || '-'}`],
      [],
      ['Kode Akun', 'Nama Akun', 'Tanggal', 'No Jurnal', 'No Referensi', 'Keterangan', 'Debet', 'Kredit', 'Saldo']
    ]

    ledgerData.forEach(account => {
      account.transactions.forEach(t => {
        wsData.push([
          account.KodeAkun,
          account.NamaAkun,
          formatDate(t.TglJurnal),
          t.NoJurnal,
          t.NoReferensi,
          t.Keterangan,
          parseFloat(t.Debet) || 0,
          parseFloat(t.Kredit) || 0,
          parseFloat(t.Saldo) || 0
        ])
      })
    })

    if (trustees.filter(t => t.Kelompok === 'Pengurus').length) {
      wsData.push([]);
      wsData.push(['PENGURUS:']);
      trustees.filter(t => t.Kelompok === 'Pengurus').forEach(t => {
        wsData.push([t.Jabatan + ' : ' + t.NamaLengkap]);
      });
    }
    if (trustees.filter(t => t.Kelompok === 'Pengawas').length) {
      wsData.push([]);
      wsData.push(['PENGAWAS:']);
      trustees.filter(t => t.Kelompok === 'Pengawas').forEach(t => {
        wsData.push([t.Jabatan + ' : ' + t.NamaLengkap]);
      });
    }

    const ws = XLSX.utils.aoa_to_sheet(wsData)

    ws['!cols'] = [
      { wch: 15 }, { wch: 30 }, { wch: 12 }, { wch: 18 }, { wch: 15 }, { wch: 40 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
    ]

    XLSX.utils.book_append_sheet(wb, ws, 'Buku Besar')
    XLSX.writeFile(wb, `Buku_Besar_${startDate}_sd_${endDate}.xlsx`)
  }

  const handleExportPDF = async () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    })

    const pageWidth = doc.internal.pageSize.width

    try {
      doc.addImage(logoBase64, 'JPEG', 14, 5, 20, 20)
    } catch (e) { console.log('Logo PDF failed:', e.message) }

    doc.setFontSize(16).setFont(undefined, 'bold')
    doc.text(coopProfile?.NamaKoperasi || 'KOPERASI SERBA USAHA', pageWidth / 2, 10, { align: 'center' })
    doc.setFontSize(9).setFont(undefined, 'normal')
    doc.text(`Badan Hukum No. : ${coopProfile?.NoBadanHukum || '-'}`, pageWidth / 2, 15, { align: 'center' })
    doc.setFontSize(8).text(coopProfile?.Alamat || '', pageWidth / 2, 20, { align: 'center' })
    doc.text(`Telp: ${coopProfile?.Telepon || '-'}  |  Email: ${coopProfile?.Email || '-'}  |  Website: ${coopProfile?.Website || '-'}  |  NPWP: ${coopProfile?.NPWP || '-'}`, pageWidth / 2, 25, { align: 'center' })

    doc.setLineWidth(0.5)
    doc.line(10, 28, pageWidth - 10, 28)
    doc.setLineWidth(0.3)
    doc.line(10, 29, pageWidth - 10, 29)

    doc.setFontSize(11).setFont(undefined, 'bold')
    doc.text('LAPORAN BUKU BESAR', pageWidth / 2, 35, { align: 'center' })
    doc.setFontSize(8).setFont(undefined, 'normal')
    doc.text(`Periode: ${formatDate(startDate)} s/d ${formatDate(endDate)} | Cabang: ${branchInfo?.NamaCabang || '-'}`, pageWidth / 2, 40, { align: 'center' })

    const tableHeaders = [['Kode Akun', 'Nama Akun', 'Tanggal', 'No Jurnal', 'No Referensi', 'Keterangan', 'Debet', 'Kredit', 'Saldo']]

    let tableData = []
    ledgerData.forEach(account => {
      account.transactions.forEach(t => {
        tableData.push([
          account.KodeAkun,
          account.NamaAkun,
          formatDate(t.TglJurnal),
          t.NoJurnal,
          t.NoReferensi,
          t.Keterangan,
          { content: formatCurrency(t.Debet), styles: { halign: 'right' } },
          { content: formatCurrency(t.Kredit), styles: { halign: 'right' } },
          { content: formatCurrency(t.Saldo), styles: { halign: 'right' } }
        ])
      })
    })

    autoTable(doc, {
      head: tableHeaders,
      body: tableData,
      startY: 45,
      theme: 'grid',
      styles: { fontSize: 7, cellPadding: 2, overflow: 'linebreak' },
      headStyles: { fillColor: [44, 62, 80], halign: 'center' },
      columnStyles: {
        6: { halign: 'right', minCellWidth: 20 },
        7: { halign: 'right', minCellWidth: 20 },
        8: { halign: 'right', minCellWidth: 20 }
      },
      margin: { left: 10, right: 10 },
      didParseCell: (data) => {
        if (data.column.index >= 6 && data.column.index <= 8 && data.section === 'body') {
          if (data.cell.text[0] && data.cell.text[0] !== '-') {
            data.cell.styles.halign = 'right';
          }
        }
      }
    })

    if (trustees.length > 0) {
      doc.setFontSize(6);
      const midX = pageWidth / 2;
      
      const pengurus = trustees.filter(t => t.Kelompok === 'Pengurus');
      const pengawas = trustees.filter(t => t.Kelompok === 'Pengawas');
      const pengurusSub = pengurus.filter(t => t.Jabatan === 'Anggota/Panitia Kredit');
      const pengurusRest = pengurus.filter(t => t.Jabatan !== 'Anggota/Panitia Kredit');

      let yL = doc.lastAutoTable.finalY + 8;
      if (pengurus.length) {
        doc.setFont(undefined, 'bold');
        doc.text('PENGURUS:', 14, yL);
        yL += 3;
        doc.setFont(undefined, 'normal');
        pengurusRest.forEach(t => {
          doc.text(`${t.Jabatan} : ${t.NamaLengkap}`, 19, yL);
          yL += 3;
        });
        if (pengurusSub.length) {
          doc.text('Anggota/Panitia Kredit :', 19, yL);
          yL += 3;
          pengurusSub.forEach((t, i) => {
            doc.text(`${i + 1}. ${t.NamaLengkap}`, 24, yL);
            yL += 3;
          });
        }
      }

      let yR = doc.lastAutoTable.finalY + 8;
      if (pengawas.length) {
        doc.setFont(undefined, 'bold');
        doc.text('PENGAWAS:', midX + 5, yR);
        yR += 3;
        doc.setFont(undefined, 'normal');
        pengawas.forEach(t => {
          doc.text(`${t.Jabatan} : ${t.NamaLengkap}`, midX + 10, yR);
          yR += 3;
        });
      }
    }

    doc.save(`Buku_Besar_${startDate}_${endDate}.pdf`)
  }

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Laporan Buku Besar</h3>
          <div className="card-tools">
            <button
              className="btn btn-sm btn-success"
              onClick={handleExportExcel}
              disabled={ledgerData.length === 0}
            >
              <i className="fas fa-file-excel mr-2"></i>
              Excel
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={handleExportPDF}
              disabled={ledgerData.length === 0}
            >
              <i className="fas fa-file-pdf mr-2"></i>
              PDF
            </button>
            <button
              className="btn btn-sm btn-primary"
              onClick={handlePrint}
              disabled={ledgerData.length === 0}
            >
              <i className="fas fa-print mr-2"></i>
              Cetak
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row mb-4 bg-light p-3 rounded">
            <div className="col-md-6">
              <label className="small font-weight-bold">TANGGAL MULAI</label>
              <div className="d-flex">
                <select className="form-control form-control-sm mr-2" style={{ width: '70px' }} value={startDay} onChange={(e) => setStartDay(e.target.value)}>
                  {Array.from({ length: 31 }, (_, i) => <option key={i + 1} value={String(i + 1).padStart(2, '0')}>{i + 1}</option>)}
                </select>
                <select className="form-control form-control-sm mr-2" style={{ width: 'auto' }} value={startMonth} onChange={(e) => setStartMonth(e.target.value)}>
                  <option value="01">Januari</option><option value="02">Februari</option><option value="03">Maret</option>
                  <option value="04">April</option><option value="05">Mei</option><option value="06">Juni</option>
                  <option value="07">Juli</option><option value="08">Agustus</option><option value="09">September</option>
                  <option value="10">Oktober</option><option value="11">November</option><option value="12">Desember</option>
                </select>
                <select className="form-control form-control-sm" style={{ width: '100px' }} value={startYear} onChange={(e) => setStartYear(e.target.value)}>
                  {Array.from({ length: 10 }, (_, i) => <option key={i} value={String(new Date().getFullYear() - 5 + i)}>{new Date().getFullYear() - 5 + i}</option>)}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <label className="small font-weight-bold">TANGGAL AKHIR</label>
              <div className="d-flex">
                <select className="form-control form-control-sm mr-2" style={{ width: '70px' }} value={endDay} onChange={(e) => setEndDay(e.target.value)}>
                  {Array.from({ length: 31 }, (_, i) => <option key={i + 1} value={String(i + 1).padStart(2, '0')}>{i + 1}</option>)}
                </select>
                <select className="form-control form-control-sm mr-2" style={{ width: 'auto' }} value={endMonth} onChange={(e) => setEndMonth(e.target.value)}>
                  <option value="01">Januari</option><option value="02">Februari</option><option value="03">Maret</option>
                  <option value="04">April</option><option value="05">Mei</option><option value="06">Juni</option>
                  <option value="07">Juli</option><option value="08">Agustus</option><option value="09">September</option>
                  <option value="10">Oktober</option><option value="11">November</option><option value="12">Desember</option>
                </select>
                <select className="form-control form-control-sm" style={{ width: '100px' }} value={endYear} onChange={(e) => setEndYear(e.target.value)}>
                  {Array.from({ length: 10 }, (_, i) => <option key={i} value={String(new Date().getFullYear() - 5 + i)}>{new Date().getFullYear() - 5 + i}</option>)}
                </select>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center">Loading...</div>
          ) : ledgerData.length === 0 ? (
            <div className="alert alert-info">Tidak ada data untuk periode yang dipilih</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Kode Akun</th>
                    <th>Nama Akun</th>
                    <th>Tanggal</th>
                    <th>No Jurnal</th>
                    <th>No Referensi</th>
                    <th>Keterangan</th>
                    <th>Debet</th>
                    <th>Kredit</th>
                    <th>Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  {ledgerData.map((account, accountIndex) => (
                    <React.Fragment key={accountIndex}>
                      {account.transactions.map((t, transIndex) => (
                        <tr key={`${accountIndex}-${transIndex}`}>
                          {transIndex === 0 && (
                            <>
                              <td rowSpan={account.transactions.length} style={{ backgroundColor: '#e8f4f8', fontWeight: 'bold' }}>
                                {account.KodeAkun}
                              </td>
                              <td rowSpan={account.transactions.length} style={{ backgroundColor: '#e8f4f8', fontWeight: 'bold' }}>
                                {account.NamaAkun}
                              </td>
                            </>
                          )}
                          <td>{formatDate(t.TglJurnal)}</td>
                          <td>{t.NoJurnal}</td>
                          <td>{t.NoReferensi}</td>
                          <td>{t.Keterangan}</td>
                          <td className="text-right">{t.Debet > 0 ? formatCurrency(t.Debet) : '-'}</td>
                          <td className="text-right">{t.Kredit > 0 ? formatCurrency(t.Kredit) : '-'}</td>
                          <td className="text-right" style={{ fontWeight: 'bold' }}>{formatCurrency(t.Saldo)}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default BukuBesar